module.exports = __webpack_public_path__ + "static/bugsnag-ab1cd3156eed97d38877ffdcfa2ab280.svg";